//import ChartV5 from '../../pages/Ministerio-conocimiento/ChartV5';
import ChartApi from '../../pages/conocimientos-rostros-publicitarios-2024/ChartApi'

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
             <ChartApi /> 
          </div>
        </div>
      </div>
    </div>
  )
}
